import React, { Component } from 'react';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import { media, mediaUrl, videoUrl, album, removeMedia, setCover, whenLoggedIn } from './PhotosRest';
import MediaStrip from './MediaStrip';
import MediaCaption from './MediaCaption';
import UploadFile from './UploadFile';
import videoOverlay from './play.png';
import closeIcon from './close.svg';
import plusIcon from './plus.png';
import plusDisabledIcon from './plus-disabled.png';
import minusIcon from './minus.png';
import minusDisabledIcon from './minus-disabled.png';
import nextIcon from './next.svg';
import prevIcon from './prev.svg';

const maxImageSize = 6;
const minImageSize = 1;
const mindist = 30;

export default class Media extends Component {
    mediaRef = React.createRef();

    constructor(props) {
	super(props);
	this.state = {
	    userlevel: 1,
	    index: 0,
	    chosen: props.album.media[0],
	    albumId: props.album.setId,
	    chosenId: props.chosenId,
	    accessName: 'self',
	    filesToUpload: [],
	    media: [],
	    size: 3,
	    prevSize: 3,
	    x: null,
	    fullscreenShowClose: false,
	    editCaption: false
	};
    }

    updateMedia = async () => {
	const a = await album(this.state.albumId);
	const m = await media(this.state.chosenId || a.media[0]);
	this.setState({
	    media: a.media,
	    chosen: m,
	    index: 0
	});
    }

    async componentDidMount() {
	if (window.innerHeight < 600 || window.innerWidth < 600) {
	    this.setState({ size: 2 });
	}
	await this.updateMedia();
	window.history.pushState({}, '', this.state.albumId + '/' + this.state.chosen.id);
	whenLoggedIn(u => this.setState({ userlevel: u.levelId }));

	document.addEventListener('touchstart', this.touchStart, false);
	document.addEventListener('touchend', this.touchEnd, false);
	document.addEventListener('fullscreenchange', this.fullscreenChange, false);
	let mediaDiv = this.mediaRef.current;
	mediaDiv.addEventListener('dragenter', this.handleDragIn);
	mediaDiv.addEventListener('dragleave', this.handleDragOut);
	mediaDiv.addEventListener('dragover', this.handleDrag);
	mediaDiv.addEventListener('drop', this.handleDrop);
    }

    componentWillUnmount() {
	document.removeEventListener('touchstart', this.touchStart, false);
	document.removeEventListener('touchend', this.touchEnd, false);
	document.removeEventListener('fullscreenchange', this.fullscreenChange, false);
	let mediaDiv = this.mediaRef.current;
	mediaDiv.removeEventListener('dragenter', this.handleDragIn);
	mediaDiv.removeEventListener('dragleave', this.handleDragOut);
	mediaDiv.removeEventListener('dragover', this.handleDrag);
	mediaDiv.removeEventListener('drop', this.handleDrop);
	this.props.parentUrl();
    }

    handleDrag = (e) => {
	e.preventDefault();
	e.stopPropagation();
    }

    handleDragIn = (e) => {
	e.preventDefault();
	e.stopPropagation();
    }

    handleDragOut = (e) => {
	e.preventDefault();
	e.stopPropagation();
    }

    handleDrop = (e) => {
	e.preventDefault();
	e.stopPropagation();
	this.addUploadFiles(e.dataTransfer.files);
    }

    addUploadFiles = files => {
	let filesToUpload = this.state.filesToUpload;
	for (var i = 0; i < files.length; i++) {
	    console.log(files[i]);
	    if (!files[i].name) return;
	    filesToUpload.push(files[i]);
	}
	this.setState({ filesToUpload: filesToUpload });
    }

    removeUploadFile = file => () => {
	let filesToUpload = this.state.filesToUpload;
	for (var i = 0; i < filesToUpload.length; i++) {
	    if (file === filesToUpload[i]) {
		filesToUpload.splice(i, 1);
		this.setState({ filesToUpload: filesToUpload });
		return;
	    }
	}
    }

    touchStart = e => this.setState({ x: e.changedTouches[0].clientX });
    touchEnd = e => {
	if (!this.state.x) { return; }
	if (e.changedTouches[0].clientX < this.state.x-mindist) {
	    // swipe left
	    this.next();
	} else if (e.changedTouches[0].clientX > this.state.x+mindist) {
	    // swipe right
	    this.prev();
	} else {
	    if (document.fullscreenElement) {
		this.toggleNav();
	    } else {
		this.fullscreen(e);
	    }
	}
    }

    playVideo = () => {
	if (this.state.chosen.videos)
	    window.open(videoUrl(this.state.chosen));
    }

    increaseSize = () => this.state.size < maxImageSize && this.setState({ size: this.state.size + 1 });
    decreaseSize = () => this.state.size > minImageSize && this.setState({ size: this.state.size - 1 });

    next = async () => {
	const idx = this.state.index < this.state.media.length-1
	      ? this.state.index + 1 : 0;
	this.setState({
	    index: idx,
	    chosenId: this.state.media[idx],
	    chosen: await media(this.state.media[idx])
	});
	window.history.pushState({}, '', '/' + this.state.albumId + '/' + this.state.chosen.id);
    }

    prev = async () => {
	const idx = this.state.index > 0
	      ? this.state.index-1 : this.state.media.length-1;
	this.setState({
	    index: idx,
	    chosenId: this.state.media[idx],
	    chosen: await media(this.state.media[idx])
	});
	window.history.pushState({}, '', '/' + this.state.albumId + '/' + this.state.chosen.id);
    }

    handleKeys = (key, event) => {
	if (key === 'esc') {
	    event.preventDefault();
	    this.props.toggle();
	    return;
	}
	if (key === 'right') { // ->
	    this.next();
	    return;
	}
	if (key === 'left') { // <-
	    this.prev();
	    return;
	}
	if (key === 'plus') {
	    this.increaseSize();
	    event.preventDefault();
	    return;
	}
	if (key === 'minus') {
	    this.decreaseSize();
	    event.preventDefault();
	    return;
	}
	if (key === 'c') {
	    this.toggleEditCaption();
	    event.preventDefault();
	    return;
	}
	if (key === 'enter') {
	    this.playVideo();
	    event.preventDefault();
	    return;
	}
    }

    choose = async mid => this.setState({
	index: this.state.media.indexOf(mid),
	chosen: await media(mid)
    });

    fullscreen = e => {
	if (['navigation', 'media', 'image'].includes(e.target.className) && !document.fullscreenElement) {
	    const el = document.getElementById('imageWrapper');
	    if (el && el.requestFullscreen) {
		this.setState({
		    prevSize: this.state.size,
		    size: maxImageSize
		});
		el.requestFullscreen();
	    }
	}
    }

    fullscreenChange = () => {
	if (!document.fullscreenElement) {
	    this.closeFullscreen();
	}
    }

    closeFullscreen = () => {
	if (document.fullscreenElement) {
	    document.exitFullscreen();
	}
	this.setState({
	    size: this.state.prevSize,
	    fullscreenShowClose: false
	});
    }

    close = () => {
	if (document.fullscreenElement) {
	    document.exitFullscreen();
	} else {
	    this.props.toggle();
	}
    }

    toggleNav = e => {
	if (document.fullscreenElement) {
	    this.setState({ fullscreenShowClose: !this.state.fullscreenShowClose });
	} else {
	    this.fullscreen(e);
	}
    }

    toggleEditCaption = () => this.setState({ editCaption: !this.state.editCaption });

    removeCurrent = async () => {
	await removeMedia(this.state.chosen.id, this.updateMedia);
    }

    setCover = () => setCover(this.state.albumId, this.state.chosen.id);

    render() {
	return (<div id='media' className='media' ref={this.mediaRef}
 		onClick={this.fullscreen}
		>
		<div className='size'>
		<img
		src={this.state.size > 1 ? minusIcon : minusDisabledIcon}
		onClick={this.decreaseSize}
		alt="decrease"
		/>
		<img
		src={this.state.size < 6 ? plusIcon : plusDisabledIcon}
		onClick={this.increaseSize}
		alt="increase"
		/>
		</div>
		<div className='close'>
		{this.state.userlevel > 1 &&
		 <div>
		 <span className='addMedia'
		 onClick={() => document.querySelector('.inputFile').click()}>
		 +
		 <input className="inputFile" type="file" multiple style={{display: 'none'}}
		 onChange={e => this.addUploadFiles(e.target.files)}
		 />
		 </span>
		 <span className='setCover' onClick={this.setCover}>cover</span>
		 <span className='removeMedia'
		 onClick={this.removeCurrent}>
		 -
		 </span>
		 </div>}
		<img src={closeIcon} id='close' className='close' onClick={this.close} alt="close"/>
		</div>
		<div className='navigation'>
		<img src={prevIcon} className='prev' onClick={this.prev} alt="previous"/>
		<img src={nextIcon} className='next' onClick={this.next} alt="next"/>
		</div>
		{this.state.chosen && 
		 <MediaCaption edit={this.state.editCaption}
		 media={this.state.chosen}
		 update={this.updateMedia}
		 toggle={this.toggleEditCaption}/>}
		{this.state.chosen && this.state.chosen.mediaType === 'still' &&
		 <img className='videoOverlay' src={videoOverlay} onClick={this.playVideo} alt="play"/>}
		{this.state.chosen &&
		 <div id='imageWrapper' className='imageWrapper'>
		 { this.state.fullscreenShowClose &&
		   <img src={closeIcon} id='fullscreenClose' className='close' onClick={this.closeFullscreen} alt='close'/> }
		 <img src={mediaUrl(this.state.size, this.state.chosen.id)}
		 className='image'
		 id='image'
		 onClick={this.toggleNav}
		 alt=""/>
		 </div>}
		{this.state.media.length > 0 &&
		 <MediaStrip parent={this} media={this.state.media} chosen={this.state.chosen.id}/>}
	        {this.state.filesToUpload.length > 0 &&
		 <div className='uploadFiles'>
		    {this.state.filesToUpload.map(f => <UploadFile key={f.name} file={f} set={this.props.album.setId} access={this.props.album.accessId} uploadFile={this.uploadFile} callback={() => { this.updateMedia(); this.removeUploadFile(f)()}}/>)}
		 </div>}
		<KeyboardEventHandler isExclusive={true}
		handleKeys={['c', 'esc', 'enter', 'right', 'left', 'plus', 'minus']}
		onKeyEvent={this.handleKeys}/>
		</div>);
    }
}
